export default "__VITE_PUBLIC_ASSET__0a000e55__"